export const ADD_ARTICLE = "ADD_ARTICLE";

export const EDIT_PROFILE__ADD_ADDRESS = "EDIT_PROFILE__ADD_ADDRESS";

//fake data generator actions 
export const ADD_CUSTOMERS = "ADD_CUSTOMERS";
export const ADD_CUSTOMERS_STATE = "ADD_CUSTOMERS_STATE";
export const ADD_DRIVERS = "ADD_DRIVERS";
export const ADD_DRIVERS_STATE = "ADD_DRIVERS_STATE";
export const ADD_NEW_SERVICES = "ADD_NEW_SERVICES";
export const ADD_NEW_SERVICES_STATE = "ADD_NEW_SERVICES_STATE";
export const ADD_NEW_DRIVERS = "ADD_NEW_DRIVERS";
export const ADD_NEW_DRIVERS_STATE = "ADD_NEW_DRIVERS_STATE";

//action for select obj from tables and set in State for using in another component
export const SELECT_CUSTOMER = "SELECT_CUSTOMER";
export const SELECT_ORDER = "SELECT_ORDER";
export const SELECT_DRIVER = "SELECT_DRIVER";

//actions those call saga methodes
export const UPDATE_CUSTOMER = "UPDATE_CUSTOMER";
export const UPDATE_CUSTOMER_STATE = "UPDATE_CUSTOMER_STATE";

export const ADD_NEW_ADDRESS = "ADD_NEW_ADDRESS";
export const ADD_NEW_ADDRESS_STATE = "ADD_NEW_ADDRESS_STATE";

export const UPDATE_DRIVER_STATE = "UPDATE_DRIVER_STATE"
export const UPDATE_DRIVER = "UPDATE_DRIVER";

export const ADD_NEW_CUSTOMER = "ADD_NEW_CUSTOMER";
export const ADD_NEW_CUSTOMER_STATE = "ADD_NEW_CUSTOMER_STATE";

export const REMOVE_CUSTOMER_ADDRESS = "REMOVE_CUSTOMER_ADDRESS";
export const REMOVE_CUSTOMER_ADDRESS_STATE = "REMOVE_CUSTOMER_ADDRESS_STATE";

export const ADD_NEW_ORDER = "ADD_NEW_ORDER";
export const ADD_NEW_ORDER_STATE = "ADD_NEW_ORDER_STATE";

export const ADD_NEW_SERVICE = "ADD_NEW_SERVICE";
export const ADD_NEW_SERVICE_STATE = "ADD_NEW_SERVICE_STATE";

export const REMOVE_SERVICE = "REMOVE_SERVICE";
export const REMOVE_SERVICE_STATE = "REMOVE_SERVICE_STATE";

export const ADD_NEW_DRIVER = "ADD_NEW_DRIVER";
export const ADD_NEW_DRIVER_STATE = "ADD_NEW_DRIVER_STATE";

export const REMOVE_DRIVER = "REMOVE_DRIVER";
export const REMOVE_DRIVER_STATE = "REMOVE_DRIVER_STATE";



//request actions
export const API_CALL_REQUEST = "API_CALL_REQUEST";
export const API_CALL_SUCCESS = "API_CALL_SUCCESS";
export const API_CALL_FAILURE = "API_CALL_FAILURE";

export const API_SEND_SMS_REQUEST = "API_SEND_SMS_REQUEST";
export const API_SEND_SMS_SUCCESS = "API_SEND_SMS_SUCCESS";
export const API_SEND_SMS_FAILURE = "API_SEND_SMS_FAILURE";


export const DATA_BASE_EXPORT_STATE = "DATA_BASE_EXPORT_STATE";
export const DATA_BASE_EXPORT = "DATA_BASE_EXPORT";

export const DATA_BASE_CUSTOMERS_IMPORT_STATE = "DATA_BASE_CUSTOMERS_IMPORT_STATE";
export const DATA_BASE_CUSTOMERS_IMPORT = "DATA_BASE_CUSTOMERS_IMPORT";

export const DATA_BASE_DRIVERS_IMPORT_STATE = "DATA_BASE_DRIVERS_IMPORT_STATE";
export const DATA_BASE_DRIVERS_IMPORT = "DATA_BASE_DRIVERS_IMPORT";

export const DATA_BASE_SERVICES_IMPORT_STATE = "DATA_BASE_SERVICES_IMPORT_STATE";
export const DATA_BASE_SERVICES_IMPORT = "DATA_BASE_SERVICES_IMPORT";


export const IMPORT_NEW_DRIVERS = "IMPORT_NEW_DRIVERS";
export const IMPORT_NEW_SERVICES = "IMPORT_NEW_SERVICES";
export const IMPORT_NEW_CUSTOMERS = "IMPORT_NEW_CUSTOMERS";

export const REMOVE__DATA = "REMOVE__DATA";


//working with datafile - data file is files like pak takta factor 
export const IMPORT_DATA_FILE = "IMPORT_DATA_FILE";
export const EXPORT_DATA_FILE = "EXPORT_DATA_FILE";
export const EXPORT_DATA_FILE_STATE = "EXPORT_DATA_FILE_STATE";


//sms actions
export const SEND_DRIVER_SMS = "SEND_DRIVER_SMS"
export const SEND_CUSTOMER_SMS = "SEND_CUSTOMER_SMS"